/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  update(id, data) {
    // Override default ApiClient update to avoid double slash 404: '/api/v1/accounts/1//'
    return axios.patch(`/api/v1/accounts/${this.accountIdFromRoute}`, data);
  }
}

export default new AccountAPI();
